<template lang="pug">
div
	v-container.pa-0
		v-row(no-gutters)
			v-col
				h1(v-html="contentpage.name")
			v-spacer
			v-col.shrink
				add-topic-dialog(v-model="showNewTopicDialog" initial-category="destination" :initial-destination="area")
				login-action(@on-click="showNewTopicDialog = true")
					template(#activator="{ on }")
						v-btn(outlined color="primary" v-on="on") {{$t('forum-navigation:new.topic')}}
	ws-content(:value="contentpage.content"  v-if="contentpage.content")
		topic-list(:topics="area.forum.topics" hide-last-visit-bar hide-destination :destination="area")
		template(v-if="pageCount > 1")
			v-pagination.my-6( v-model="page" :length="pageCount" :total-visible="10")
			v-divider.mb-6
</template>

<script>
import gql from 'graphql-tag';
import TopicList from '@dengl/common/components/forum/topic-list.vue';
import AddTopicDialog from '@/components/forum/add-topic-dialog';
import MetaFragment from '@/components/graphql/metaFragment.graphql';

const areaForumQuery = gql`
	query areaForum(
		$slug: String!
		$path: String
		$fallback: String
		$pagination: PaginationInput
	) {
		contentpage(path: $path, fallback: $fallback) {
			id
			name
			slug
			content {
				markdown
			}
			...MetaFragment
		}
		area(slug: $slug) {
			id
			name
			slug
			country {
				id
				name
				countryCode
				slug
			}
			region {
				id
				name
				slug
			}
			forum: topics(pagination: $pagination) {
				...TopicListFragment
			}
		}
	}
	${MetaFragment}
	${TopicList.fragments}
`;

export default {
	nuxtI18n: {
		paths: {
			'nl-NL': '/skigebieden/:area/forum',
			'de-DE': '/skigebiete/:area/forum',
			'nl-BE': '/skigebieden/:area/forum'
		}
	},
	components: { TopicList, AddTopicDialog },
	layout: 'default',
	// eslint-disable-next-line @milqmedia/milq/page-has-meta
	asyncData({ params, app, route, query }) {
		const variables = {
			slug: params.area,
			pagination: { page: parseInt(query.page) || 1 },
			path: route.path,
			fallback: route.path.replace(params.area, '_area'),
			page: parseInt(query.page) || 1
		};
		return app.$graphClient
			.query({
				query: areaForumQuery,
				variables,
				errorPolicy: 'all'
			})
			.then(({ data, errors }) => {
				if (!data.contentpage) {
					return app.httpError(404, null, 'area-forum-index-01', errors);
				}
				if (errors) {
					throw errors[0];
				}

				app.interpolater(data.contentpage.meta, ['title', 'description']);
				app.interpolater(data.contentpage.content, ['markdown']);
				app.interpolater(data.contentpage, ['name']);

				data.pageCount = Math.ceil(data.area.forum.pagination.total / 50);

				data.contentpage.meta.pagination = {
					total: data.pageCount,
					page: variables.page
				};

				app.meta(data.contentpage.meta);
				app.ads({});
				app.areaBreadcrumbs(data.area, {
					[app.i18n.t(`destination-navigation.forum`)]: {
						name: 'areas-area-forum',
						params: { area: data.area.slug }
					}
				});

				return { ...data, ...variables };
			});
	},
	data() {
		return {
			page: 1,
			showNewTopicDialog: false
		};
	},
	head() {
		return {
			...this.$structuredData()
		};
	},

	watch: {
		page: {
			handler(value) {
				const query = value === 1 ? {} : { page: value };
				this.$router.push({ query });
			}
		}
	},
	watchQuery: ['page'],
	created() {
		this.$emit('update:showSidebar', false);
	}
};
</script>
